@let title = $title();
@let isLoading = !!(isLoading$ | async);

<tui-block-status [tuiSkeleton]="isLoading">
  <x-svg-icon
    tuiSlot="top"
    icon="x-icon::empty-ufo"
    class="h-full! w-full! empty-block-ufo-svg"
  ></x-svg-icon>
  @if (title) {
    <h4 class="x-font-body-1-bold x-text-dark-main">
      {{ title }}
    </h4>
  }
</tui-block-status>
